import React, { useEffect, useState } from "react";
import logo from "../Assets/images/logo.png";
import { KeyIcon } from "../Assets/svgs/KeyIcon";
import { passwordValidation } from "../Common/Validations";
import { SuccessModel } from "../Model/SuccessModel";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../Redux/Slice/Authentication/ResetPasswordSlice";
import { useDispatch } from "react-redux";
import { ErrorModel } from "../Model/ErrorModel";
import { checkInvitation } from "../Redux/Slice/Authentication/CheckInvitationSlice";
import { setNewUserPassword } from "../Redux/Slice/Authentication/SetPasswordSlice";
import { OpenEye } from "../Assets/svgs/OpenEye";
import { CloseEye } from "../Assets/svgs/CloseEye";
import {Loader } from "../Common/Loader";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [passwordType, setPasswordType] = useState(false);
  const [passwordType2, setPasswordType2] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState("");
  const [passowrdError, setPasswordError] = useState({
    passWordValid: "",
    passwordMatch: "",
  });
  
  useEffect(() => {
    let token = location.pathname.split("/")[2];
    if(token){
      setToken(token);
      checkToken(token);
    }

  }, [location]);

  const checkToken = async (token) => {
    setIsLoading(true);
    const result = await dispatch(checkInvitation({ inviteToken: token }));
    if (
      checkInvitation.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      if(location.search){
        const query = location.search.split("=");
        if(query[1] === "reset"){
          setIsReset(true);
          // navigate("/otpverification", {state:{email:result?.payload?.data?.email, isMfaEnabled: true , reset:true}})
        }else{
          setIsReset(false);
        }
      }
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModal(true);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setPassword(e.target.value);
    const isValid = passwordValidation(value);
    let errors = passowrdError;
    if (isValid || value === "") {
      errors = { ...passowrdError, passWordValid: "" };
    } else {
      errors ={
        ...passowrdError,
        passWordValid: "Password must be 8 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character",
      };
    }
    if (newPassword && (value !== newPassword)) {
      errors.passwordMatch = "Passwords don't match";
    } else {
      errors.passwordMatch = "";
    }
    setPasswordError(errors);
  };
  const handleChangeNew = (e) => {
    const value = e.target.value;
    setNewPassword(e.target.value);
    if (value.match(password) && password.match(value) || value === "") {
      setPasswordError({ ...passowrdError, passwordMatch: "" });
    } else {
      setPasswordError({
        ...passowrdError,
        passwordMatch: "Passwords don't match",
      });
    }
  };

  const handleSubmit = async () => {
    if (newPassword.match(password)) {
      if (isReset) {
        const body = {
          inviteToken: token,
          newPassword: password,
        };

        const result = await dispatch(setNewUserPassword(body));
        if (
          setNewUserPassword.fulfilled.match(result) &&
          result?.payload?.success === true
        ) {
          setSuccessMessage("Password Reset Successfully!");
          setSuccessModel(true);
          setTimeout(() => {
            navigate("/");
            setSuccessModel(false);
          }, 2000);
        } else {
          setErrorMessage(result?.payload?.error?.message);
          setErrorModal(true);
          setTimeout(() => {
            setErrorModal(false);
          }, 2000);
        }
      } else {
        const body = {
          inviteToken: token,
          newPassword: password,
        };
        const result = await dispatch(setNewUserPassword(body));
        if (
          setNewUserPassword.fulfilled.match(result) &&
          result?.payload?.success === true
        ) {
          setSuccessMessage("Password Set Successfully!");
          setSuccessModel(true);
          setTimeout(() => {
            navigate("/");
            setSuccessModel(false);
          }, 2000);
        } else {
          setErrorMessage(result?.payload?.error?.message);
          setErrorModal(true);
          setTimeout(() => {
            setErrorModal(false);
          }, 2000);
        }
      }
    }
  };

  return (
    <section className="layoutContainer layoutContainer--full">
      {loading ? <Loader /> :""}
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          <div className="page__head">
            <div className="page__head__logo">
              <img src={logo} alt="Logo | Vox App" />
            </div>
          </div>
          <div className="page__body">
            <div className="emailVerificationCard">
              <div className="branding">
                <div className="branding__logo">
                  <KeyIcon />
                </div>
                <div className="branding__info textCenter">
                  <h1 className="title title--h1">{!isReset ? "Set":"Reset"} Password</h1>
                  <p className="text pb_0">
                    Please {!isReset ? "Set":"Reset"} your password to <br />
                    continue
                  </p>
                </div>
              </div>
              <div className="emailVerificationCard__form">
                <div className="form__group">
                  <label for="password" className="form__label">
                    Password
                  </label>
                  <div className="form__groupField">
                    <input
                      type={passwordType ? "text":"password"}
                      id="password"
                      className="form__input"
                      autoComplete="off"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      maxLength={16}
                      placeholder="Enter your Password"
                    />
                    <button
                    className="btn"
                    onClick={(e) => {
                      setPasswordType(!passwordType);
                    }}
                  >
                    {passwordType ? <OpenEye /> : <CloseEye />}
                  </button>
                  </div>
                  <div className="form__error">
                    {passowrdError.passWordValid}
                  </div>
                </div>
                <div className="form__group">
                  <label for="password2" className="form__label">
                    Re-enter password
                  </label>
                  <div className="form__groupField">
                    <input
                      type={passwordType2 ? "text":"password"}
                      id="password"
                      className="form__input"
                      name="newPassword"
                      value={newPassword}
                      onChange={handleChangeNew}
                      maxLength={16}
                      placeholder="Re-enter your Password"
                    />
                    <button
                    className="btn"
                    onClick={(e) => {
                      setPasswordType2(!passwordType2);
                    }}
                  >
                    {passwordType2 ? <OpenEye /> : <CloseEye />}
                  </button>
                  </div>
                  <div className="form__error">
                    {passowrdError.passwordMatch}
                  </div>
                </div>
                <div className="form__button textCenter">
                  <button
                    onClick={handleSubmit}
                    disabled={
                      passowrdError.passWordValid != "" ||
                      passowrdError.passwordMatch != "" ||
                      password === "" ||
                      newPassword === "" ||
                      !newPassword.match(password)
                    }
                    className="btn btn__primary btn--full"
                    type="submit"
                  >
                    Submit
                    {/* {!isReset ? "Set":"Reset"} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {errorModal ? <ErrorModel message={errorMessage} /> : ""}
    </section>
  );
};
